var _path, _g, _g2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerB4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_17_1",
    "data-name": "Component 17 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.381,
    height: 180,
    viewBox: "0 0 64.381 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14385",
    "data-name": "Path 14385",
    d: "M27.9,20.448,17.448,10,7,20.448Z",
    transform: "translate(74.381 29.001) rotate(90)",
    fill: "#f26a6c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    fill: "none",
    stroke: "#f26a6c",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 2.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    transform: "translate(0 173)",
    fill: "none",
    stroke: "#f26a6c",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 2.5,
    fill: "none"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14382",
    "data-name": "Path 14382",
    d: "M-20784.33,523.447l41.537-.062s3.52-.149,4.828,1.271,1.047,4.472,1.047,4.472V688.154s.047,4.841-1.605,6.55-6.615,1.861-6.615,1.861h-39.191",
    transform: "translate(20790.83 -519.881)",
    fill: "none",
    stroke: "#f26a6c",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerB4);
export default __webpack_public_path__ + "static/media/per_b_4.c1feef742d202778552d3913251adf0c.svg";
export { ForwardRef as ReactComponent };